import React from 'react';
import {useTranslation} from "react-i18next";
import './style.less';

const {
    _class: {
        Common: { Price },
    },
} = Mobi2Go;

const BalanceViewer = ({balance}) => {

    const {t} = useTranslation('order.balances');

    const {
        name,
        amount
    } = balance;

    const pricedAmount = new Price(amount);

    const className = block => `m2g-customer-balances${block || ''}`;

    return (
        <div>
            <div
                className={className('__balance')}
            >
                {t('price', {
                    price: pricedAmount,
                })}
            </div>
            <div
                className={className('__title')}
            >
                {name}
            </div>
        </div>
    );
};

export default BalanceViewer;
